import { useEffect, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { FullTabInt } from '../../interfaces';
import { isNil } from '../../utils/global/helper';

function usePersistedTab({
  paramKey = 'tab',
  defaultTab,
  tabs,
}: {
  paramKey?: string;
  defaultTab: number;
  tabs: FullTabInt[];
}) {
  const [searchParams, setSearchParams] = useSearchParams();
  const paramTab = searchParams.get(paramKey) as string | null;

  const tab = paramTab
    ? tabs.find(t => t.id === paramTab && !t.hidden)?.tabId
    : defaultTab;

  useEffect(() => {
    if (paramTab && isNil(tab)) {
      const newParams = new URLSearchParams(searchParams);
      newParams.delete(paramKey);
      setSearchParams(newParams);
    }
  }, [tab, paramKey, paramTab, searchParams, setSearchParams]);

  const onChangeTab = (newTab: number) => {
    const newTabObj = tabs.find(t => t.tabId === newTab);
    if (!newTabObj) return;
    setSearchParams({ [paramKey]: String(newTabObj.id) });
  };

  const tabVal = useMemo(() => tab || defaultTab, [tab, defaultTab]);

  return [tabVal, onChangeTab] as const;
}

export default usePersistedTab;
